<div class="modal-body">
  <div class="card">
    <div class="modal-header modal-close">
      <button type="button" class="close" aria-label="Close" (click)="closeModal()"><span
        aria-hidden="true">&times;</span></button>
    </div>
    <div class="card-header modal-card-header">
      <h4 class="form-section">
        <i class="ft-repeat"></i> {{ 'smsMessageDetails.title' | translate }}</h4>
    </div>
    <div class="card-body">
      <div class="px-3">

        <!-- SmsMessageId -->
        <div class="card-field">
          <div class="card-field-label">{{ 'smsMessageDetails.smsMessageIdFieldLabel' | translate }}</div>
          <div class="card-field-content">{{ currentObject.SmsMessageId }}</div>
        </div>

        <!-- CreatedAt -->
        <div class="card-field">
          <div class="card-field-label">{{ 'smsMessageDetails.createdAtFieldLabel' | translate }}</div>
          <div class="card-field-content">{{ currentObject.CreatedAt | date:'d-M-y HH:mm:ss' }}</div>
        </div>

        <!-- SentAt -->
        <div class="card-field">
          <div class="card-field-label">{{ 'smsMessageDetails.sentAtFieldLabel' | translate }}</div>
          <div class="card-field-content">{{ currentObject.SentAt | date:'d-M-y HH:mm:ss' }}</div>
        </div>

        <!-- Status -->
        <div class="card-field">
          <div class="card-field-label">{{ 'smsMessageDetails.statusFieldLabel' | translate }}</div>
          <div class="card-field-content"><i [ngClass]="currentObject.Status.IconClass"
                                             title="{{currentObject.Status.Description}}"></i></div>
        </div>

        <!-- Sender -->
        <div class="card-field">
          <div class="card-field-label">{{ 'smsMessageDetails.senderFieldLabel' | translate }}</div>
          <div class="card-field-content">{{ currentObject.Sender }}</div>
        </div>

        <!-- RecipientPhonenumber -->
        <div class="card-field">
          <div class="card-field-label">{{ 'smsMessageDetails.recipientPhonenumberFieldLabel' | translate }}</div>
          <div class="card-field-content">{{ currentObject.RecipientPhonenumber }}</div>
        </div>

        <!-- Content -->
        <div class="card-field">
          <div class="card-field-label">{{ 'smsMessageDetails.contentFieldLabel' | translate }}</div>
          <div class="card-field-content">{{ currentObject.Content }}</div>
        </div>

        <div class="form-actions">
          <button type="button" class="btn btn-secondary btn-raised mr-1 float-right" (click)="closeModal()">
            <i class="ft-x-square"></i> {{ 'buttons.closeText' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
